export * from './activity';
export * from './after-sale';
export * from './coupon';
export * from './distributorCenter';
export * from './member';
export * from './order';
export * from './placeOrder';

import gql from 'graphql-tag';

export const ERROR_FRAGMENT = gql`
  fragment ErrorResult on ErrorResult {
    errorCode
    message
  }
`;
